<template>
  <div class="expansion-title-bar">
    <el-avatar :size="adaptationVars.avatarSize" class="user-avatar">
      <img :src="avatarImg" />
    </el-avatar>
    <div class="user-name">
      <span>{{ `HI,${userInfo.userName}` }}</span>
    </div>
    <div class="switch-user-btn">
      <el-tooltip content="切换用户" placement="top">
        <span :class="['iconfont', 'icon-switch-user']" @click="switchUser"></span>
      </el-tooltip>
    </div>
    <div class="fill"></div>
    <div class="user-info info-card">
      <div :class="['iconfont', 'icon-user-large', 'info-icon']"></div>
      <div class="info-detail">
        <div class="info-value">{{ userInfo.userName }}</div>
        <div class="info-des">当前用户</div>
      </div>
    </div>
    <div class="balance-info info-card">
      <div :class="['iconfont', 'icon-yuan-large', 'info-icon']"></div>
      <div class="info-detail">
        <div class="info-value">{{ `￥${userInfo.balance}` }}</div>
        <div class="info-des">用户余额</div>
      </div>
    </div>
    <el-button class="recharge-btn" @click="onReCharge">
      <span :class="['iconfont', 'icon-recharge']"></span>
      <span class="btn-text">充值</span>
    </el-button>
  </div>
</template>
<script>
import adaptation from '@/mixins/adaptation'
import avatarImg from '@/assets/images/avatar.png'
export default {
  name: 'TitleBar',
  mixins: [adaptation],
  adaptationVarsDefine: {
    avatarSize: 80
  },
  props: {
    userInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      avatarImg: avatarImg,
      adaptationVars: {
        avatarSize: 80
      }
    }
  },
  methods: {
    //切换用户
    switchUser() {
      this.$emit('switchUser')
    },
    onReCharge() {
      this.$emit('onReCharge')
    }
  }
}
</script>
<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme(
  'expansion-title-bar',
  (
    --expansion-title-bar-background:
      linear-gradient(90deg, #3eacff 0%, #49bff2 52.73%, #5353e5 100%),
    --expansion-title-bar-avatar-border-color: #fff,
    --expansion-title-bar-info-card-background: rgba(0, 0, 0, 0.16),
    --expansion-title-bar-info-card-des-color: rgba(255, 255, 255, 0.65),
    --expansion-title-bar-info-card-recharge-btn-color: #fff,
    --expansion-title-bar-info-card-recharge-btn-background:
      linear-gradient(100deg, #ff7c32 -3.24%, #fdda25 103.7%)
  ),
  (
    --expansion-title-bar-background:
      linear-gradient(90deg, #3eacff99 0%, #49bff299 52.73%, #5353e599 100%),
    --expansion-title-bar-avatar-border-color: #fff,
    --expansion-title-bar-info-card-background: rgba(0, 0, 0, 0.06),
    --expansion-title-bar-info-card-des-color: rgba(255, 255, 255, 0.65),
    --expansion-title-bar-info-card-recharge-btn-color: #fff,
    --expansion-title-bar-info-card-recharge-btn-background:
      linear-gradient(100deg, #ff7c32 -3.24%, #fdda25 103.7%)
  )
);
.expansion-title-bar {
  @include adaptation(
    (
      --expansion-title-bar-height: 128px,
      --expansion-title-bar-avatar-margin-left: 40px,
      --expansion-title-bar-avatar-border-width: 1px,
      --expansion-title-bar-name-margin-left: 24px,
      --expansion-title-bar-name-font-size: 28px,
      --expansion-title-bar-name-height: 41px,
      --expansion-title-bar-switch-user-btn-margin-left: 12px,
      --expansion-title-bar-switch-user-btn-icon-font-size: 24px,
      --expansion-title-bar-info-card-min-width: 188px,
      --expansion-title-bar-info-card-height: 79px,
      --expansion-title-bar-info-card-border-radius: 2px,
      --expansion-title-bar-info-card-margin-left: 16px,
      --expansion-title-bar-info-card-padding: 8px 24px,
      --expansion-title-bar-info-card-icon-font-size: 35px,
      --expansion-title-bar-info-card-detail-margin-left: 8px,
      --expansion-title-bar-info-card-detail-value-font-size: 18px,
      --expansion-title-bar-info-card-detail-value-line-height: 26px,
      --expansion-title-bar-info-card-detail-value-margin-bottom: 12px,
      --expansion-title-bar-info-card-detail-des-font-size: 12px,
      --expansion-title-bar-info-card-recharge-btn-height: 40px,
      --expansion-title-bar-info-card-recharge-btn-width: 92px,
      --expansion-title-bar-info-card-recharge-btn-margin: 0 34px 0 45px,
      --expansion-title-bar-info-card-recharge-btn-padding: 8px 16px,
      --expansion-title-bar-info-card-recharge-btn-line-height: 24px,
      --expansion-title-bar-info-card-recharge-btn-icon-font-size: 24px,
      --expansion-title-bar-info-card-recharge-btn-text-height: 24px,
      --expansion-title-bar-info-card-recharge-btn-text-font-size: 14px,
      --expansion-title-bar-info-card-recharge-btn-text-margin-left: 8px
    )
  );
  display: flex;
  align-items: center;
  height: var(--expansion-title-bar-height);
  background: var(--expansion-title-bar-background);
  color: var(--base-color-white);

  .user-avatar {
    margin-left: var(--expansion-title-bar-avatar-margin-left);
    border: var(--expansion-title-bar-avatar-border-width) solid
      var(--expansion-title-bar-avatar-border-color);
  }

  .user-name {
    margin-left: var(--expansion-title-bar-name-margin-left);
    font-size: var(--expansion-title-bar-name-font-size);
    line-height: var(--expansion-title-bar-name-height);
    height: var(--expansion-title-bar-name-height);
  }

  .switch-user-btn {
    margin-left: var(--expansion-title-bar-switch-user-btn-margin-left);

    .icon-switch-user {
      font-size: var(--expansion-title-bar-switch-user-btn-icon-font-size);
    }
  }

  .fill {
    flex-grow: 1;
  }

  .info-card {
    min-width: var(--expansion-title-bar-info-card-min-width);
    height: var(--expansion-title-bar-info-card-height);
    border-radius: var(--expansion-title-bar-info-card-border-radius);
    background: var(--expansion-title-bar-info-card-background);
    margin-left: var(--expansion-title-bar-info-card-margin-left);
    text-align: right;
    display: flex;
    align-items: center;
    padding: var(--expansion-title-bar-info-card-padding);

    .info-icon {
      font-size: var(--expansion-title-bar-info-card-icon-font-size);
    }

    .info-detail {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      margin-left: var(--expansion-title-bar-info-card-detail-margin-left);

      .info-value {
        font-size: var(--expansion-title-bar-info-card-detail-value-font-size);
        line-height: var(--expansion-title-bar-info-card-detail-value-line-height);
        margin-bottom: var(--expansion-title-bar-info-card-detail-value-margin-bottom);
        white-space: nowrap;
      }

      .info-des {
        color: var(--expansion-title-bar-info-card-des-color);
        font-size: var(--expansion-title-bar-info-card-detail-des-font-size);
      }
    }
  }

  .recharge-btn.el-button--default {
    height: var(--expansion-title-bar-info-card-recharge-btn-height);
    line-height: var(--expansion-title-bar-info-card-recharge-btn-line-height);
    width: var(--expansion-title-bar-info-card-recharge-btn-width);
    margin: var(--expansion-title-bar-info-card-recharge-btn-margin);
    padding: var(--expansion-title-bar-info-card-recharge-btn-padding);
    border: none;
    color: var(--expansion-title-bar-info-card-recharge-btn-color);
    background: var(--expansion-title-bar-info-card-recharge-btn-background);

    /deep/ span {
      display: flex;
      .icon-recharge {
        font-size: var(--expansion-title-bar-info-card-recharge-btn-icon-font-size);
      }

      .btn-text {
        height: var(--expansion-title-bar-info-card-recharge-btn-text-height);
        font-size: var(--expansion-title-bar-info-card-recharge-btn-text-font-size);
        margin-left: var(--expansion-title-bar-info-card-recharge-btn-text-margin-left);
      }
    }

    &:hover,
    &:focus {
      opacity: 0.8;
      border: none;
    }
  }
}
</style>
